const sensorsReducer = (
  state = {
    loading: false,
    data: null,
  },
  action
) => {
  switch (action.type) {
    case "SET_SENSORS_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };

    case "SET_SENSORS_DATA":
      return {
        ...state,
        data: action.payload.data,
      };

    case "RESET":
      return {
        loading: false,
        data: null,
      };

    default:
      return state;
  }
};
export default sensorsReducer;
